import { Box, Text } from "@mantine/core";
import classes from "../list.module.css";

type Props = {
  paid?: number | null;
  total?: number | null;
};

export function PaymentProgressCell({ paid, total }: Props) {
  const p = Number(paid ?? 0);
  const tot = Number(total ?? 0);
  const pct = tot > 0 ? Math.max(0, Math.min(100, Math.round((p / tot) * 100))) : 0;

  return (
    <Box className={classes.paymentProgress}>
      <Box className={classes.paymentBar}>
        <Box className={classes.paymentBarFill} w={`${pct}%`} />
      </Box>
      <Text className={classes.paymentPct}>{pct}%</Text>
    </Box>
  );
}
